import { Fragment } from 'react';

export function General() {
  return (
    <Fragment>
      If you feel that any materials appearing on our site are offensive, objectionable or potentially infringing or defamatory, please contact us, using the details below and including full details of the nature of your complaint and the materials to which the complaint relates.
      <br /><br />
      The Agreement is between you and us. Except as set out below, no other person shall have any rights to enforce any of its terms.
      <br /><br />
      You may not transfer any of your rights under these terms to any other person. We may transfer our rights under these terms to another business where we reasonably believe your rights will not be affected.
      <br /><br />
      If you breach these terms and we choose to ignore this, we will still be entitled to our rights and remedies at a later date or in any other situation where you breach the terms.
      <br /><br />
      Each of the paragraphs of these terms operates separately. If any court or relevant authority decides that any of them are unlawful or unenforceable, the remaining paragraphs will remain in full force and effect.
      <br /><br />
      We shall not be responsible for any breach of these terms caused by circumstances beyond our reasonable control.
      <br /><br />
      If you have any concerns about the site or material which appears on our site or services you purchased from us, please contact us <a href="/contact-us">here</a> or write to us at our office at Level39, One Canada Square, Canary Wharf, London E14 5AB. If we have been unable to resolve your complaint or dispute please note that disputes may be submitted for online resolution to the European Commission Online Dispute Resolution platform which is available <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage" target="_blank">here</a>
    </Fragment>
  );
}


export default General;
